import React from 'react'

export default function  Service() {
    return (
        <>
      
        <div id='service' className='Services'>
            <div className='container'>
             <div className='Service-head'>
             <div className='Common'>
                 
             <h3 className='heading'>Services</h3>
              <h1 className='main-heading'>My Service</h1>
              <p className='main-content'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Nihil, excepturi! Repellat quibusdam adipisci qui vero?</p>
              <div className='commonBorder'></div>
              </div> 
              <div className='row'>
               <div className='col-6'>
                   <div className='servicebox1
                   '>
                       <i class="icon fab fa-github-square"></i>
                       <div className='service-head '>
                         Web Design
                       </div>
                       <div className='service-p'>
                           Lorem ipsum dolor sit amet consectetur adipisicing elit. Tempore, soluta.
                       </div>
                        </div>
               </div>
               <div className='col-6'>
                   <div className='servicebox2
                   '>
                      <i class="icon fas fa-browser"></i>
                       <div className='service-head '>
                         Web Devolepment
                       </div>
                       <div className='service-p'>
                           Lorem ipsum dolor sit amet consectetur adipisicing elit. Tempore, soluta.
                       </div> 
                        </div>
               </div>

              </div>
                 
                 
              
              

             </div>

            </div>
            
        </div>
        </>
    )
}
